module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "system-info"
  }, [_c('section', [_c('header', [_vm._v("web:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('section', [_c('header', [_vm._v("server:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.system.version))])]), _vm._v(" "), _c('section', [_c('header', [_vm._v("node:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.system.node))])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.cpuPrompt,
      "placement": "right"
    }
  }, [_c('el-progress', {
    staticClass: "progress",
    attrs: {
      "percentage": _vm.cpuPercent,
      "textInside": true,
      "strokeWidth": 18
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.memPrompt,
      "placement": "right"
    }
  }, [_c('el-progress', {
    staticClass: "progress",
    attrs: {
      "percentage": _vm.memPercent,
      "textInside": true,
      "strokeWidth": 18
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0505b28c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/OsUsage.vue
// module id = 155
// module chunks = 1